var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutusbackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 729,
    height: 1458,
    viewBox: "0 0 729 1458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49 0v1144M181.302 0v1144M361.117 0v1144M540.931 0v1144M720.745 0v1144M900.558 0v1144M1080.37 0v1144M1260.19 0v1144M1440 0v1144M1 1112.01h1438.51M1 932.033h1438.51M1 752.053h1438.51M1 572.073h1438.51M1 392.092h1438.51M1 212.112h1438.51M1 32.132h1438.51",
    stroke: "url(#yidlo9gbga)",
    strokeOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M615 678h139v780c-76.768 0-139-62.23-139-139V678z",
    fill: "url(#rhcwkm6a9b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "yidlo9gbga",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 572 -719.5 0 720.5 572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rhcwkm6a9b",
    x1: 749.886,
    y1: 678,
    x2: 469.578,
    y2: 707.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F4F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusbackground2);
export default __webpack_public_path__ + "static/media/About us background 2.49534038a6619ec76f17ba63bb08235f.svg";
export { ForwardRef as ReactComponent };